import { render } from "./AllTradesFileDownload.vue?vue&type=template&id=56841474&scoped=true"
import script from "./AllTradesFileDownload.vue?vue&type=script&lang=js"
export * from "./AllTradesFileDownload.vue?vue&type=script&lang=js"

import "./AllTradesFileDownload.vue?vue&type=style&index=0&id=56841474&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56841474"]])

export default __exports__